<template>
  <header class="relative clear-left py-2">
    <h1
      class="text-28 sm:text-28 tracking-tight font-bold leading-snug"
      :class="{ 'text-black-500': !isOnedioVideo, 'text-white': isOnedioVideo }"
    >
      <ArticleBadge v-if="hasBadge" :size="44" class="float-right relative" :badge="article.badges[0]" />
      {{ article.title }}
    </h1>
  </header>
</template>

<script>
import { defineComponent, inject, computed } from '@nuxtjs/composition-api';
import { isVideoArticle } from '../utils/articleUtils';
import ArticleBadge from '~/modules/card/components/ArticleBadge.vue';

export default defineComponent({
  components: { ArticleBadge },
  props: {
    stn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article');
    const hasBadge = computed(() => article.badges?.length);
    const isOnedioVideo = computed(() => isVideoArticle(article) && !props.stn);
    return { hasBadge, article, isOnedioVideo };
  },
});
</script>
